module.exports = __webpack_public_path__ + "img/point_redeem_coupon.ea1e36bb.svg";